export enum ClassType {
  CLASS,
  RECORD,
  INTERFACE,
}
